import { Grid, useMediaQuery } from '@material-ui/core';
import DefaultButton, { OrangeButton } from 'components/Button';
import { AssuranceIcon } from 'images';
import React from 'react';
import { ContentText, PrimaryTitleCard } from './styles';
export interface SuccessFailedType {
  icon: String;
  title: String;
  secondTitle: String;
  actionOne: Function;
  actionTwo: Function;
  actionOneTitle: String;
  actionTwoTitle: String;
}
const SuccessFailed = ({
  icon,
  title,
  secondTitle,
  actionOne,
  actionTwo,
  actionOneTitle,
  actionTwoTitle,
}: SuccessFailedType) => {
  const isNotMobile = useMediaQuery('(min-width:960px)');
  return (
    <Grid
      container
      spacing={2}
      direction="column"
      alignItems="center"
      style={isNotMobile ? { minWidth: 800 } : {}}
    >
      <Grid xs={10} md={6} item>
        <img src={AssuranceIcon[icon as any]} alt="" />
      </Grid>
      <Grid xs={10} md={6} item>
        <PrimaryTitleCard fontSize="20">{title}</PrimaryTitleCard>
      </Grid>
      <Grid xs={10} md={6} item>
        <ContentText>{secondTitle}</ContentText>
      </Grid>
      <Grid xs={10} md={6} item>
        <OrangeButton onClick={actionOne} variant="contained" color="secondary">
          {actionOneTitle}
        </OrangeButton>
      </Grid>
      <Grid xs={10} md={6} item>
        <DefaultButton onClick={actionTwo}>{actionTwoTitle}</DefaultButton>
      </Grid>
    </Grid>
  );
};
export default SuccessFailed;
